

































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import sleep from '../../../utils/sleep';
import randomGenerator from '../../../utils/random';


type wire_t = {
    ini: number|string;
    end: number|string;
    color: string;
}

type wire2_t = {
    path: string;
    cut: boolean;
    cutA: string;
    cutB: string;
    color: string;
}

type layout_t = {
    connectorsA: string|null[];
    connectorsB: string|null[];
    wires: wire_t[];
    seed: number;
}


const DEF_LAYOUT = () => ({
    connectorsA: [
        'A', 'B', 'C',null,'D'
    ],
    connectorsB: [
        'E', 'F', 'G',
    ],
    wires: [
        {ini:'A', end:1, color:'#4254f5'},
        {ini:1, end:0, color:'#f54242'},
        {ini:'D', end:2, color:'#42f55a'},
    ],
    seed: 2,
});




@Component({
    components: {
    },
})
export default class WirecutVue extends Vue {

    // The code that solves the keypad
    @Prop({default: DEF_LAYOUT})
    private layout!: layout_t;

    @Prop({default: '012'})
    private code!: string;

    @Prop({default: false})
    private reseteable!: boolean;

    @Prop({default: null})
    private model!: string;

    private current_code = '';


    private CONNECTOR_SIZE=20;
    private CONNECTOR_MARGIN=30;
    private CONTENT_WIDTH=300;

    private enabled = true;

    private wires: wire2_t[] = [];

    // Leds with their classes
    private led1 = {on: true};
    private led2 = {on: false};

    get CONTENT_HEIGHT(){

        const rows = Math.max(
            this.layout.connectorsA.length,
            this.layout.connectorsB.length,
        );

        return (this.CONNECTOR_MARGIN + this.CONNECTOR_SIZE) * (rows) +
            this.CONNECTOR_MARGIN;

    }


    getConnectorIdx(idx_or_name: string|number){

        if(typeof idx_or_name !== 'string'){
            return idx_or_name;
        }

        for(let i=0; i<this.layout.connectorsA.length; i++){
            if(this.layout.connectorsA[i] === idx_or_name){
                return i;
            }
        }

        for(let i=0; i<this.layout.connectorsB.length; i++){
            if(this.layout.connectorsB[i] === idx_or_name){
                return i;
            }
        }

        return -1;

    }


    mounted(){

        this.ledsUpdate();


        const random = randomGenerator(this.layout.seed);

        this.wires = this.layout.wires.map((w:wire_t) => {

            const y = (y:number) =>
                (this.CONNECTOR_SIZE + this.CONNECTOR_MARGIN) * y +
                this.CONNECTOR_MARGIN + this.CONNECTOR_SIZE/2;
            const x = (x:number) =>
                this.CONNECTOR_SIZE/2 + this.CONNECTOR_MARGIN +
                (this.CONTENT_WIDTH-this.CONNECTOR_SIZE-this.CONNECTOR_MARGIN*2) * x;

            const ini_idx = this.getConnectorIdx(w.ini);
            const end_idx = this.getConnectorIdx(w.end);


            const top = Math.min(ini_idx, end_idx);
            const bot = Math.max(ini_idx, end_idx);

            const ini = x(0) + " " + y(ini_idx);
            const mid = x(random(0.2,0.8)) + " " + y(random(top-1, bot+1));
            const end = x(1) + " " + y(end_idx);

            let path = `M ${ini} Q ${mid} ${end}`;


            // Cut
            const cut_x = x(random(0.2,0.8))
            const cut_y = y(random(top, bot));

            const mid1 = random(x(0)+10,cut_x-25) + " " + y(random(top, bot));
            const mid2 = random(cut_x+25,x(1)-10) + " " + y(random(top, bot));

            const cutA = `M ${ini} Q ${mid1} ${cut_x-20} ${cut_y}`;
            const cutB = `M ${end} Q ${mid2} ${cut_x+20} ${cut_y}`;




            return {
                path,
                cut: false,
                cutA,
                cutB,   
                color: w.color,
            };

        });
     

    }

    async ledsUpdate(){

        while(this.enabled){
            await sleep(500);
            if(!this.enabled) return;
            this.led1.on = !this.led1.on;
            this.led2.on = !this.led2.on;
        }
        

    }


    cutWire(idx: number){

        if(!this.enabled) return;

        this.current_code += idx;
        this.wires[idx].cut = true;

        if(this.code === this.current_code){
            this.show_success();
            return;
        }

        let valid = true;
        for(let i=0; i<this.current_code.length; i++){
            if(this.code[i] !== this.current_code[i]) valid = false;
        }

        if(!valid){
            this.show_failure();
        }


    }
   
       async show_success(){

        this.enabled = false;

        this.led1.on = false;
        this.led2.on = false;

         await sleep(1000);
     

        this.$emit('success');


    }



    async show_failure(){

        this.enabled = false;

        this.led1.on = true;
        this.led2.on = true;

        for(let t = 200; t>20; t-=10){
            await sleep(t);
            this.led1.on = !this.led1.on;
            this.led2.on = !this.led2.on;
        }

        this.led1.on = true;
        this.led2.on = true;

        this.$emit('failure');

        if(this.reseteable){
            this.reset();
        }



    }


    reset(){

        this.current_code = '';

        this.wires.forEach((w,idx) => {
            this.wires[idx].cut = false;
        })

        this.enabled = true;
        this.led1.on = true;
        this.led2.on = false;
        this.ledsUpdate();

    }


}

